angular
    .module('vppApp')

    .filter('titlecase', titleCaseFilter)

    .directive('phoneInput', phoneInputDirective)
    .filter('tel', telFilter)

    .directive('dobInput', dobDirective)
    .filter('dob', dobFilter)

    .directive('zipInput', zipInputDirective)
    .filter('zip', zipFilter);


function titleCaseFilter() {
    return function (input) {
        var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;

        input = input.toLowerCase();
        return input.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
            if (index > 0 && index + match.length !== title.length &&
                match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" &&
                (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
                title.charAt(index - 1).search(/[^\s-]/) < 0) {
                return match.toLowerCase();
            }

            if (match.substr(1).search(/[A-Z]|\../) > -1) {
                return match;
            }

            return match.charAt(0).toUpperCase() + match.substr(1);
        });
    }
};


dobDirective.$inject = ['$filter', 'dateFilter', '$browser'];

function dobDirective($filter, dateFilter, $browser) {
    return {
        // restrict : "AC",
        require: 'ngModel',
        link: function ($scope, $element, $attrs, ngModelCtrl) {
            // console.log("PhoneInputDirective.link()");
            var listener = function () {
                var value = $element.val().replace(/[^0-9]/g, '');
                $element.val($filter('dob')(value, false));
                // $element.val(dateFilter(value,'MM/dd/yyyy'));
            };

            // This runs when we update the text field
            ngModelCtrl.$parsers.push(function (viewValue) {
                return viewValue.replace(/[^0-9]/g, '').slice(0, 10);
            });

            // This runs when the model gets updated on the scope directly and keeps our view in sync
            ngModelCtrl.$render = function () {
                $element.val($filter('dob')(ngModelCtrl.$viewValue, false));
                // $element.val(dateFilter($element.val(),'MM/dd/yyyy'));
            };

            $element.bind('change', listener);
            $element.bind('keydown', function (event) {
                var key = event.keyCode;
                // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
                // This lets us support copy and paste too
                if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
                    return;
                }
                $browser.defer(listener); // Have to do this or changes don't get picked up properly
            });

            $element.bind('paste cut', function () {
                $browser.defer(listener);
            });
        }
    };
}

phoneInputDirective.$inject = ['$filter', '$browser', '$timeout'];

function phoneInputDirective($filter, $browser, $timeout) {
    return {
        // restrict : "AC",
        require: 'ngModel',
        link: function ($scope, $element, $attrs, ngModelCtrl) {
            // console.log("PhoneInputDirective.link()");
            var listener = function () {
                if($element.val().length){
                    var value = $element.val().replace(/[^0-9]/g, '');
                    $element.val($filter('tel')(value, false));

                    if($element.val().length == 14){
                        ngModelCtrl.$setValidity('minlength', true);
                    } else {
                        ngModelCtrl.$setValidity('minlength', false);
                    }
                }
            };

            // This runs when we update the text field
            ngModelCtrl.$parsers.push(function (viewValue) {
                return viewValue.replace(/[^0-9]/g, '').slice(0, 10);
            });

            ngModelCtrl.$formatters.push(function (value) {
                 return $filter('tel')(value, false);
            });

            // This runs when the model gets updated on the scope directly and keeps our view in sync
            ngModelCtrl.$render = function () {
                $element.val($filter('tel')(ngModelCtrl.$viewValue, false));
            };

            $element.bind('change', function () {
                $timeout(function(){
                    listener();
                });
            });

            $element.bind('keydown', function (event) {
                var key = event.keyCode;
                // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
                // This lets us support copy and paste too
                if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
                    return;
                }
                $timeout(function(){
                    listener();
                });
            });

            $element.bind('paste cut', function () {
                $timeout(function(){
                    listener();
                });
            });
        }
    };
}


function dobFilter() {
    return function (s) {
        // console.log(s);
        if (!s) {
             //console.log(s);
            return '';
        }
        // s = s.toString();

        // var value = s.toString().trim().replace(/^\+/, '');

        // if (value.match(/[^0-9]/)) {
        //   return s;
        // }

        var month, day, year,
            maxDayMonths = [
                {
                    maxDays: 31,
                    months: [1, 3, 5, 7, 8, 10, 12],
                    exceptionMonths: [],
                    isExceptionYear: function(year) {
                        return false;
                    }
                }, {
                    maxDays: 30,
                    months: [4, 6, 9, 11],
                    exceptionMonths: [],
                    isExceptionYear: function(year) {
                        return false;
                    }
                }, {
                    maxDays: 29,
                    months: [2],
                    exceptionMonths: [],
                    isExceptionYear: function(year) {
                        return false;
                    }
                }, {
                    maxDays: 28,
                    months: [],
                    exceptionMonths: [2],
                    isExceptionYear: function(year) {
                        return year%4 !== 0;
                    }
                }
            ],
            maxDayInMonth = 99;

        // strip slashes before formatting
        // this prevents weird dates like 12////1/2/2012
        s = s.replace(/\//g, '');

        if (s.length > 4) {
            year = s.slice(4);
        }
        if (s.length > 2) {
            day = s.slice(2, 4);
        }

        month = s.slice(0, 2);
        if(month.charAt(0) !== '0') {
            month = Math.min(month, 12);
        } else if(month.length > 1) {
            month = '0' + Math.max(month, 1);
        }

        if(year && parseInt(year) > 999) {
            year = Math.min(year, new Date().getFullYear());
            year = Math.max(year, 1800);
           // console.log(year);
        }

        if(day) {
          /*
            for (var i = 0; i < maxDayMonths.length; i++) {
                // check to see if it's a leap year or not (aka an exception)
                var isExeption = year && year > 999 && maxDayMonths[i].exceptionMonths.indexOf(month) && maxDayMonths[i].isExceptionYear(year);
                 console.log('month ~~~,', month, 'i', i, 'index: ', maxDayMonths[i].months.indexOf(parseInt(month)));
                if (maxDayMonths[i].months.indexOf(parseInt(month)) > -1 || isExeption) {
                     console.log('isException day', isExeption);
                    maxDayInMonth = maxDayMonths[i].maxDays;
                }
            }
             console.log('maxDayInMonth', maxDayInMonth);

            if(parseInt(day) >= 10) {
                day = Math.min(day, maxDayInMonth).toString();
            } else if(day.length > 1) {
                day = '0' + Math.max(day, 1);
            }
            */
        }

       //console.log('monthSSS', month, ', day', day, ', year', year);

        if (year) {
            return month + '/' + day + '/' + year;
        } else if (day) {
            return month + '/' + day;
        } else {
            return month;
        }

    };
}

function telFilter() {
    return function (tel) {
        // console.log(tel);
        if (!tel) {
            return undefined;
        }

        var value = tel.toString().trim().replace(/^\+/, '');

        if (value.match(/[^0-9]/)) {
            return tel;
        }

        var country, city, number;

        switch (value.length) {
            case 1:
            case 2:
            case 3:
                city = value;
                break;

            default:
                city = value.slice(0, 3);
                number = value.slice(3);
        }

        if (number) {
            if (number.length > 3) {
                number = number.slice(0, 3) + '-' + number.slice(3, 7);
            }
            else {
                number = number;
            }

            return ("(" + city + ") " + number).trim();
        }
        else {
            return "(" + city;
        }

    };
}


function zipInputDirective($filter, $browser) {
    return {
        // restrict : "AC",
        require: 'ngModel',
        link: function ($scope, $element, $attrs, ngModelCtrl) {
            // console.log("zipInputDirective.link()");
            var listener = function () {
                var value = $element.val().replace(/[^0-9]/g, '');
                $element.val($filter('zip')(value, false));
            };

            // This runs when we update the text field
            ngModelCtrl.$parsers.push(function (viewValue) {
                return viewValue.replace(/[^0-9]/g, '').slice(0, 5);
            });

            // This runs when the model gets updated on the scope directly and keeps our view in sync
            ngModelCtrl.$render = function () {
                $element.val($filter('zip')(ngModelCtrl.$viewValue, false));
            };

            $element.bind('change', listener);
            $element.bind('keydown', function (event) {
                var key = event.keyCode;
                // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
                // This lets us support copy and paste too
                if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
                    return;
                }
                $browser.defer(listener); // Have to do this or changes don't get picked up properly
            });

            $element.bind('paste cut', function () {
                $browser.defer(listener);
            });
        }
    };
}

function zipFilter() {
    return function (zip) {
        // console.log(zip);
        if (!zip) {
            return '';
        }

        var value = zip.toString().trim().replace(/^\+/, '');

        if (value.match(/[^0-9]/)) {
            return zip; //.slice(0,9);
        }

        var part1, part2;

        switch (value.length) {
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
                part1 = value.slice(0, 5);
                // part2 = value.slice(5, 9);
                break;
            default:
                part1 = value.slice(0, 5);
        }

        if (part2) {
            return part1 + "-" + part2;
        }
        return zip.slice(0, 5);

    };
}
